import { styled } from "styled-components";
import { ImageProps } from "./types";

const Image = styled.img<ImageProps>`
  ${({ $borderRadius }) => $borderRadius !== undefined && `border-radius: ${$borderRadius};`}
  width: ${({ $imgSize, $imgWidth }) => $imgSize || $imgWidth || '50%'};
  height: ${({ $imgSize, $imgHeight }) => $imgSize || $imgHeight || '50%'};
  object-fit: cover;
`;

export default Image;